/**
 * @generated SignedSource<<07ab4de75721935837d0b41078aab8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionWarningConfigState = "DISABLED" | "ENABLED" | "NOT_APPLICABLE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion$data = {
  readonly warningConfig: {
    readonly failingBuild: JiraVersionWarningConfigState;
    readonly openPullRequest: JiraVersionWarningConfigState;
    readonly openReview: JiraVersionWarningConfigState;
    readonly unreviewedCode: JiraVersionWarningConfigState;
  } | null | undefined;
  readonly " $fragmentType": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion";
};
export type ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion$key = {
  readonly " $data"?: ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion",
  "selections": [
    {
      "concreteType": "JiraVersionWarningConfig",
      "kind": "LinkedField",
      "name": "warningConfig",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "openPullRequest"
          },
          "action": "NONE",
          "path": "warningConfig.openPullRequest"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "openReview"
          },
          "action": "NONE",
          "path": "warningConfig.openReview"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "unreviewedCode"
          },
          "action": "NONE",
          "path": "warningConfig.unreviewedCode"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "failingBuild"
          },
          "action": "NONE",
          "path": "warningConfig.failingBuild"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "e4b994880d16817a096017c816579b1b";

export default node;
